import { requestImage } from '..'
import { HttpMethods } from '../apiHelper'

export const getImageByName = (imageName, user) => {
  return requestImage(
    `/profil/image/${imageName}`,
    HttpMethods.GET,
    null,
    user
  )
}
